import { GzDialogWebComponent } from 'apps/webcomponents/src/ui/gzDialog';
import { GzDialog } from 'apps/webcomponents/src/ui/gzDialog/component/GzDialog';
import { attachDialogFooterListeners, getDeleteDialogButtons } from '../shared/dialogUtils';

export class DeleteDialog {
  static open(translateFn: Function, hasGhostItems = false): GzDialogWebComponent {
    const dialogBody = document.createElement('div');
    dialogBody.innerHTML = `<p>${
      hasGhostItems
        ? translateFn(
            'Your selection also includes objects that are no longer bound to any managed endpoint. These objects are always marked in the grid as grayed out. Are you sure you want to delete?'
          )
        : translateFn('Are you sure you want to delete the selected items?')
    }</p>`;

    const footerContent = getDeleteDialogButtons(translateFn);
    const dialogConfigs: GzDialog = {
      headline: translateFn('Delete'),
      bodyContent: dialogBody,
      isOpen: true,
      footerContent,
    };

    const dialog = GzDialogWebComponent.buildDialogElement(dialogConfigs);

    attachDialogFooterListeners(footerContent, dialog);

    return dialog;
  }
}
